import React from "react";
import { useRequiredParams } from "../../../hooks/useRequiredParams.ts";
import { GameDetail } from "./Detail.tsx";

export const RouteWrapper: React.FC = () => {
  const { gameId } = useRequiredParams(["gameId"]);
  return <GameDetail gameId={gameId} />;
};
